module.exports = "<style>nav, ma-menu-bar {\n        display:none;\n    }</style><div class=login-form><h1>Karaoketosing Backoffice Login</h1><form ng-submit=\"controller.login(email, password)\"><input ng-model=email id=username placeholder=Email> <input type=password ng-model=password placeholder=Password id=password><div class=submit><input type=submit value=\"Log In\"></div></form></div>";


//////////////////
// WEBPACK FOOTER
// ./js/auth/template.html
// module id = 439
// module chunks = 0